import React from 'react'
import MobileDrawer from '../MobileComponents/MobileDrawer';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
// import ArrowBackIcon from "@mui/icons-material/ArrowBack";
// import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
// import CreateIcon from "@mui/icons-material/Create";
import { useNavigate } from 'react-router-dom';
import SortOutlinedIcon from '@mui/icons-material/SortOutlined';
import { blue } from '@mui/material/colors';
// import Fab from '@mui/material/Fab';
// import AddIcon from '@mui/icons-material/Add';
// import Button from '@mui/material/Button';
// import Typography from '@mui/material/Typography';
// import Modal from '@mui/material/Modal';
// import CloseIcon from '@mui/icons-material/Close';
// import AttachmentIcon from '@mui/icons-material/Attachment';
// import LogoutRoundedIcon from '@mui/icons-material/LogoutRounded';
// import AvatarPic from "../../assets/images/avtarPic.png";
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
import avtar from "../../assets/images/Profile-Picture.jpg";
import Maid from "../../assets/images/MaidWhite.png";
import Cook from "../../assets/images/CookWhite.png";
import Milk from "../../assets/images/MilkWhite.png";
import CarWash from "../../assets/images/CarWashWhite.png";
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';

// const style = {
//   position: 'absolute',
//   top: '50%',
//   left: '50%',
//   transform: 'translate(-50%, -50%)',
//   width: 400,
//   bgcolor: 'background.paper',
//   borderRadius: 2,
//   boxShadow: 10,
//   p: 3,
// };
function CustomTabPanel(props) {

  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

function MobileServiceProvider() {
    const navigate = useNavigate();
    const [value, setValue] = React.useState(0);
    const handleChange = (event, newValue) => {
        setValue(newValue);
    };
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
      setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
      setAnchorEl(null);
    };
  return (
    <div>
        <div>
        <div className="drawerFixedPatch"></div>
        <div className="drawerWithTop">
          <MobileDrawer />
          <h1>Service Provider</h1>
        </div>
        </div>
    <div className='topSpace'></div>
    <div className='tabView'>
      <div className='AddServiceProviderView'>
        <div className='AddServiceProviderBtn' onClick={()=>navigate('/MobileAddServiceProvider')}>
          <p className='AddServiceProviderTxt'>Add Service Provider</p>
        </div>
      </div>
      <Box sx={{ width: '100%' }}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
          <Tab label="My Service Provider" {...a11yProps(0)} style={{width:'25%'}}/>
          <Tab label="All Service" {...a11yProps(1)} style={{width:'25%'}}/>
          <Tab label="Pending" {...a11yProps(2)} style={{width:'25%'}}/>
          <Tab label="Rejected" {...a11yProps(3)} style={{width:'25%'}}/>
        </Tabs>
      </Box>
      
      <CustomTabPanel value={value} index={0}>
        <div className='SearchSortDivTab'>
          <input type='text' placeholder='Search' />
          <IconButton
        onClick={handleClick}
        size="small"
        sx={{ ml: 0 }}
        aria-controls={open ? 'account-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        >
        <SortOutlinedIcon sx={{ fontSize: 30, color: blue[800] }} />
      </IconButton>
      <Menu
          anchorEl={anchorEl}
          id="account-menu"
          open={open}
          onClose={handleClose}
          onClick={handleClose}
          PaperProps={{
            elevation: 0,
            sx: {
              overflow: 'visible',
              filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
              mt: 1.5,
              '& .MuiAvatar-root': {
                width: 32,
                height: 32,
                ml: -0.5,
                mr: 1,
              },
              '&::before': {
                content: '""',
                display: 'block',
                position: 'absolute',
                top: 0,
                right: 14,
                width: 10,
                height: 10,
                bgcolor: 'background.paper',
                transform: 'translateY(-50%) rotate(45deg)',
                zIndex: 0,
              },
            },
          }}
          transformOrigin={{ horizontal: 'right', vertical: 'top' }}
          anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
        >
          <MenuItem onClick={handleClose}>
            Oldest to Newest
          </MenuItem>
          <MenuItem onClick={handleClose}>
            Newest to Oldest
          </MenuItem>
      </Menu>
        </div>
        <div className="famDetailsListInrMob">
        <div className="famDetailsListTo">
          <div className="alignfamDetailsListToPro" onClick={()=> navigate('/MobileServiceProviderDetails')}>
            <div className="ImageViewRound">
            <img src={avtar} className="useImage" alt='altimg'/>
            </div>
            <div className="detailsDiMob">
              <h1>User Name</h1>
              <div className="mobWithIco">
                <LocalPhoneIcon />
                <p>9881789836</p>
              </div>
            </div>
          </div>
          <div>
          <p className='ticketTimedeteTxt'>Service Type</p>
          <p className='pollTimeTxt'>Maid</p>
          </div>
        </div>
        <div className='dividerCommon' />
        <div className='famDetailsListTo'>
        <div className='pollsTitlDescView margineTop10'>
          <p className='pollsDescripTxt'>Houses Working</p>
          <p className='pollsTitleTxt'>WingA-502, WingB-104</p>
        </div>
        </div>
        </div>
      </CustomTabPanel>
      <CustomTabPanel value={value} index={1}>
        <div className='SearchSortDivTab'>
          <input type='text' placeholder='Search' />
          <IconButton
        onClick={handleClick}
        size="small"
        sx={{ ml: 0 }}
        aria-controls={open ? 'account-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        >
        <SortOutlinedIcon sx={{ fontSize: 30, color: blue[800] }} />
      </IconButton>
      <Menu
          anchorEl={anchorEl}
          id="account-menu"
          open={open}
          onClose={handleClose}
          onClick={handleClose}
          PaperProps={{
            elevation: 0,
            sx: {
              overflow: 'visible',
              filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
              mt: 1.5,
              '& .MuiAvatar-root': {
                width: 32,
                height: 32,
                ml: -0.5,
                mr: 1,
              },
              '&::before': {
                content: '""',
                display: 'block',
                position: 'absolute',
                top: 0,
                right: 14,
                width: 10,
                height: 10,
                bgcolor: 'background.paper',
                transform: 'translateY(-50%) rotate(45deg)',
                zIndex: 0,
              },
            },
          }}
          transformOrigin={{ horizontal: 'right', vertical: 'top' }}
          anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
        >
          <MenuItem onClick={handleClose}>
            Oldest to Newest
          </MenuItem>
          <MenuItem onClick={handleClose}>
            Newest to Oldest
          </MenuItem>
      </Menu>
        </div>
        <div className='AllServiceProviderView'>
          <div className='ServiceProviderBtnView' onClick={()=>navigate('/MobileSpecificServiceProvider')}>
            <img src={Maid} alt='img'/>
            <p className='ServiceProviderTxt'>Maid</p>
          </div>
          <div className='ServiceProviderBtnView ServiceBGColor1' onClick={()=>navigate('/MobileSpecificServiceProvider')}>
            <img src={Cook} alt='img'/>
            <p className='ServiceProviderTxt'>Cook</p>
          </div>
          <div className='ServiceProviderBtnView ServiceBGColor2' onClick={()=>navigate('/MobileSpecificServiceProvider')}>
            <img src={CarWash} alt='img'/>
            <p className='ServiceProviderTxt'>Car Washer</p>
          </div>
          <div className='ServiceProviderBtnView ServiceBGColor3' onClick={()=>navigate('/MobileSpecificServiceProvider')}>
            <img src={Milk} alt='img'/>
            <p className='ServiceProviderTxt'>Milk Service</p>
          </div>
        </div>
      </CustomTabPanel>
      <CustomTabPanel value={value} index={2}>
        <div className='SearchSortDivTab'>
          <input type='text' placeholder='Search' />
          <IconButton
        onClick={handleClick}
        size="small"
        sx={{ ml: 0 }}
        aria-controls={open ? 'account-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        >
        <SortOutlinedIcon sx={{ fontSize: 30, color: blue[800] }} />
      </IconButton>
      <Menu
          anchorEl={anchorEl}
          id="account-menu"
          open={open}
          onClose={handleClose}
          onClick={handleClose}
          PaperProps={{
            elevation: 0,
            sx: {
              overflow: 'visible',
              filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
              mt: 1.5,
              '& .MuiAvatar-root': {
                width: 32,
                height: 32,
                ml: -0.5,
                mr: 1,
              },
              '&::before': {
                content: '""',
                display: 'block',
                position: 'absolute',
                top: 0,
                right: 14,
                width: 10,
                height: 10,
                bgcolor: 'background.paper',
                transform: 'translateY(-50%) rotate(45deg)',
                zIndex: 0,
              },
            },
          }}
          transformOrigin={{ horizontal: 'right', vertical: 'top' }}
          anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
        >
          <MenuItem onClick={handleClose}>
            Oldest to Newest
          </MenuItem>
          <MenuItem onClick={handleClose}>
            Newest to Oldest
          </MenuItem>
      </Menu>
        </div>
        <div className="famDetailsListInrMob">
        <div className="famDetailsListTo">
          <div className="alignfamDetailsListToPro" onClick={()=> navigate('/MobileServiceProviderDetails')}>
            <div className="ImageViewRound">
            
            <img src={avtar} className="useImage" alt='img'/>
            </div>
            <div className="detailsDiMob">
              <h1>User Name</h1>
              <div className="mobWithIco">
                <LocalPhoneIcon />
                <p>9881789836</p>
              </div>
            </div>
          </div>
          <div>
          <p className='ticketTimedeteTxt'>Service Type</p>
          <p className='pollTimeTxt'>Maid</p>
          </div>
        </div>
        </div>
      </CustomTabPanel>
      <CustomTabPanel value={value} index={3}>
        <div className='SearchSortDivTab'>
          <input type='text' placeholder='Search' />
          <IconButton
        onClick={handleClick}
        size="small"
        sx={{ ml: 0 }}
        aria-controls={open ? 'account-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        >
        <SortOutlinedIcon sx={{ fontSize: 30, color: blue[800] }} />
      </IconButton>
      <Menu
          anchorEl={anchorEl}
          id="account-menu"
          open={open}
          onClose={handleClose}
          onClick={handleClose}
          PaperProps={{
            elevation: 0,
            sx: {
              overflow: 'visible',
              filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
              mt: 1.5,
              '& .MuiAvatar-root': {
                width: 32,
                height: 32,
                ml: -0.5,
                mr: 1,
              },
              '&::before': {
                content: '""',
                display: 'block',
                position: 'absolute',
                top: 0,
                right: 14,
                width: 10,
                height: 10,
                bgcolor: 'background.paper',
                transform: 'translateY(-50%) rotate(45deg)',
                zIndex: 0,
              },
            },
          }}
          transformOrigin={{ horizontal: 'right', vertical: 'top' }}
          anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
        >
          <MenuItem onClick={handleClose}>
            Oldest to Newest
          </MenuItem>
          <MenuItem onClick={handleClose}>
            Newest to Oldest
          </MenuItem>
      </Menu>
        </div>
        <div className="famDetailsListInrMob">
        <div className="famDetailsListTo">
          <div className="alignfamDetailsListToPro" onClick={()=> navigate('/MobileServiceProviderDetails')}>
            <div className="ImageViewRound">
            
            <img src={avtar} className="useImage" alt='img'/>
            </div>
            <div className="detailsDiMob">
              <h1>User Name</h1>
              <div className="mobWithIco">
                <LocalPhoneIcon />
                <p>9881789836</p>
              </div>
            </div>
          </div>
          <div>
          <p className='ticketTimedeteTxt'>Service Type</p>
          <p className='pollTimeTxt'>Maid</p>
          </div>
        </div>
        <div className='dividerCommon' />
        <div className='famDetailsListTo'>
        <div className='pollsTitlDescView margineTop10'>
          <p className='pollsDescripTxt'>Message</p>
          <p className='pollsTitleTxt'>Rejected Reason Message</p>
        </div>
        </div>
        </div>
      </CustomTabPanel>
      
      </Box>
    </div>
    </div>
  )
}

export default MobileServiceProvider